'use client'

import { cn } from '@utils'
import { useEffect, useRef, useState } from 'react'

export default function FixedSection({
  children,
  rounded = false,
}: {
  children: React.ReactNode
  rounded?: boolean
}) {
  const [height, setHeight] = useState(0)
  const [isInView, setIsInView] = useState(false)
  const innerRef = useRef<HTMLDivElement>(null)
  const bottomRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    // 获取innerRef的元素的高度，包括在dom发生变化的时候
    const handleResize = () => {
      if (innerRef.current) {
        const height = innerRef.current.getBoundingClientRect().height
        // innerRef.current.style.height = `${height}px`
        setHeight(height)
      }
    }
    handleResize()

    window.addEventListener('resize', handleResize)
    // dom发生变化时，重新计算高度
    const observer = new MutationObserver(handleResize)
    if (innerRef.current) {
      observer.observe(innerRef.current, {
        attributes: true,
        childList: true,
        subtree: true,
      })
    }
    // 清理函数
    return () => {
      window.removeEventListener('resize', handleResize)
      observer.disconnect()
    }
  }, [])

  useEffect(() => {
    // 判断bottomRef是否进入视口
    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsInView(entry.isIntersecting)
      },
      {
        rootMargin: '0px',
        threshold: 1,
      }
    )
    if (bottomRef.current) {
      observer.observe(bottomRef.current)
    }
    return () => {
      observer.disconnect()
    }
  }, [])

  return (
    <>
      <section
        style={{ height: height ? `${height}px` : 'auto' }}
        className={cn(
          'relative bg-white overflow-hidden',
          isInView ? 'z-10' : 'z-20',
          { 'rounded-t-4xl': rounded }
        )}
      >
        <div
          ref={innerRef}
          className={cn(isInView ? 'fixed w-full bottom-0' : '')}
        >
          {children}
        </div>
        {/* <div style={{ height: `${isInView && height ? height : 0}px` }}></div> */}
      </section>
      <div ref={bottomRef}></div>
    </>
  )
}
